/*! Copyright (C) 2017 Clearstream Fly Fishing, LLC
 * All rights reserved. */

var customizer = {};

customizer._updating = false;

// Update after choosing an option.
customizer.update = function update() {
    if (customizer._updating) {
        return;
    }
    try {
        customizer._updating = true;
        customizer.updateInternal();
    } finally {
        customizer._updating = false;
    }
};

customizer.updateInternal = function updateInternal() {
    var customizerDiv = $("#customizerDiv");
    var selectedOverlays = [];
    var material = $("#custom_material", customizerDiv).val();

    // Enable colors for UNI-Thread or Monofilament.
    $("#custom_uni_color1, #custom_uni_color2, #custom_tipcolor", customizerDiv).prop("disabled", material !== "UNI-Thread");
    $("#custom_mono_color1, #custom_mono_color2", customizerDiv).prop("disabled", material !== "Monofilament");
    $("#color1UniDiv, #color2UniDiv, #tipColorDiv", customizerDiv).toggle(material === "UNI-Thread");
    $("#color1MonoDiv, #color2MonoDiv", customizerDiv).toggle(material === "Monofilament");

    // Set extra for non-standard color or different first and second color.
    var foundNsPrice = false; // To only charge the non-standard price once.
    $("select:enabled", customizerDiv).each(function(s, selectElem) {
        var changedColorPrices = false;
        $("option[data-nsprice]", selectElem).each(function(i, elem) {
            var oldPrice = $(elem).attr("data-price") === undefined ? null : $(elem).attr("data-price");
            var newPrice = foundNsPrice || $(selectElem).is($("#custom_uni_color2")) && $(elem).val() === $("#custom_uni_color1").val() ? null : $(elem).attr("data-nsprice");
            if (oldPrice !== newPrice) {
                $(elem).attr("data-price", newPrice);
                changedColorPrices = true;
            }
        });
        if ($("option[data-nsprice]:selected", selectElem).length) {
            foundNsPrice = true;
        }
        if (changedColorPrices) {
            $(selectElem).trigger("change");
        }
    });

    // Get tip and option colors.
    var tipColor = $("#custom_tipcolor:enabled", customizerDiv).val();
    var tipOption = $("#custom_tipoption:enabled", customizerDiv).val();

    // Determine selected overlays.
    if (!material) {
        // Material not selected, show instructions instead.
        $(".customizerOverlayStarted", customizerDiv).hide();
        $(".customizerOverlayInstructions", customizerDiv).show();
    } else {
        $(".customizerOverlayInstructions", customizerDiv).hide();
        $(".customizerOverlayStarted", customizerDiv).show();

        customizer.pushAll(selectedOverlays, customizer.getOverlays($("select:enabled option:selected[data-overlay]", customizerDiv), "data-overlay"));
    
        if (tipOption === "Thread Loop") {
            customizer.pushAll(selectedOverlays, customizer.getOverlays($("select:enabled option:selected[data-overlay-loop]", customizerDiv), "data-overlay-loop"));
        } else {
            customizer.pushAll(selectedOverlays, customizer.getOverlays($("select:enabled option:selected[data-overlay-ring]", customizerDiv), "data-overlay-ring"));
        }
        if (!tipColor || tipColor === "None") {
            customizer.pushAll(selectedOverlays, customizer.getOverlays($("select:enabled option:selected[data-overlay-endc]", customizerDiv), "data-overlay-endc"));
            if (tipOption === "Thread Loop") {
                customizer.pushAll(selectedOverlays, customizer.getOverlays($("select:enabled option:selected[data-overlay-loopc]", customizerDiv), "data-overlay-loopc"));
            } else {
                customizer.pushAll(selectedOverlays, customizer.getOverlays($("select:enabled option:selected[data-overlay-ringc]", customizerDiv), "data-overlay-ringc"));
            }
        }
    }

    // Set overlays to show.
    $(".customizerOverlay", customizerDiv).each(function(i, elem) {
        var visible = selectedOverlays.indexOf($(elem).prop("id")) !== -1;
        customizer.toggleOverlay(elem, visible);
    });
    customizer.updateImagesLoaded(); // Must call this after toggleOverlay.

    var variantInfo = variantInfo  = customizer.getSelectedVariantInfo();

    if (variantInfo.base && !variantInfo.variant) {
        alert("Product variant not found: " + variantInfo.base + " " + variantInfo.custom);
    }

    if (variantInfo.variant) {
        $("#custom_id", customizerDiv).val(variantInfo.variant.id);
        $("#custom_total", customizerDiv).text((variantInfo.variant.price / 100).toFixed(2));
        $(".totalSpan", customizerDiv).show();
    } else {
        $("#custom_id", customizerDiv).val("");
        $("#custom_total", customizerDiv).text("");
        $(".totalSpan", customizerDiv).hide();
    }
};

customizer.getSelectedVariantInfo = function getSelectedVariantInfo() {
    var customizerDiv = $("#customizerDiv");
    var selectedVariant = null;
    var customTotal = 0;
    var base = null;
    var baseOptionPropName = null;
    var customOptionPropName = null;

    // Get option property names ("option#"). 
    for (var i = 0; i < window.product.options.length; i++) {
        switch (window.product.options[i]) {
            case "Base":
                baseOptionPropName = "option" + (i + 1);
                break;
            case "Custom":
                customOptionPropName = "option" + (i + 1);
                break;
        }
    }

    // Compute total of customization from selected option [data-price] attributes.
    $("select:enabled option:selected", customizerDiv).each(function(i, elem) {
        var price = $(elem).attr("data-price");
        if (price) {
            customTotal += parseFloat(price);
        }
    });

    // Determine selected variant.

    // Base matches the selected option [data-base-variant] attribute.
    $("select:enabled option:selected[data-base-variant]", customizerDiv).each(function(i, elem) {
        base = $(elem).attr("data-base-variant");
    });
    // Custom matches the padded additional price (format "+$0.00").
    var customTotalPadded = "+$" + customTotal.toFixed(2);
    for (var j = 0; j < window.product.variants.length; j++) {
        var variant = window.product.variants[j];
        if (variant[baseOptionPropName] === base && variant[customOptionPropName] === customTotalPadded) {
            selectedVariant = variant;
            break;
        }
    }

    return {
        base: base,
        custom: customTotalPadded,
        variant: selectedVariant,
    };
};

// Call updateImagesLoaded() or updateImagesLoadedDelay() after toggling a set of overlays.
customizer.toggleOverlay = function toggleOverlay(elem, visible) {
    if (visible) {
        // Load images that use [data-src] attribute for delayed loading.

        // Check elem and descendants for img[data-src].
        $(elem).find("img[data-src]").addBack().filter("img[data-src]").each(function(i, elem) {
            if ($(elem).attr("data-src") && $(elem).prop("src") !== $(elem).attr("data-src")) {
                $(elem).prop("src", $(elem).attr("data-src"));
            }
        });
        // Use imagesLoaded to detect when all images in this overlay have loaded.
        if (!$(elem).attr("data-img-loaded")) {
            $(elem).imagesLoaded(function() {
                if (!$(elem).attr("data-img-loaded")) {
                    $(elem).attr("data-img-loaded", Date.now());
                    customizer.updateImagesLoadedDelay();
                }
            });
        }
    }
    // Toggle the overlay.
    $(elem).toggle(visible);
};

customizer.updateImagesLoaded = function updateImagesLoaded() {
    var customizerDiv = $("#customizerDiv");
    var numberLoaded = $(".customizerOverlay:visible[data-img-loaded]", customizerDiv).length;
    var numberTotal =  $(".customizerOverlay:visible", customizerDiv).length;

    //if (numberTotal > 0) {
    //    console.log("Images " + numberLoaded + "/" + numberTotal);
    //}

    if (numberTotal > 0 && numberLoaded < numberTotal) {
        $(".customizerOverlayWaiting", customizerDiv).show();
        // Show Loading message, but only if it is taking too long.
        $(".customizerOverlayLoading", customizerDiv).clearQueue().delay(100).show(0);
    } else {
        $(".customizerOverlayWaiting", customizerDiv).hide();
        $(".customizerOverlayLoading", customizerDiv).clearQueue().hide(0);
    }
};

customizer._updateImagesLoadedPending = false;
customizer.updateImagesLoadedDelay = function updateImagesLoadedDelay() {
    if (!customizer._updateImagesLoadedPending) {
        customizer._updateImagesLoadedPending = true;
        setTimeout(function() {
            customizer._updateImagesLoadedPending = false;
            customizer.updateImagesLoaded();
        });
    }
};

customizer.getOverlays = function getOverlays(query, attributeName) {
    var overlays = [];
    query.each(function(i, elem) {
        var attributeValue = $(elem).attr(attributeName);
        if (attributeValue) {
            var splits = $(elem).attr(attributeName).split(" ");
            for (var j = 0; j < splits.length; j++) {
                overlays.push(splits[j]);
            }
        }
    });
    return overlays;
};

customizer.pushAll = function pushAll(target, source) {
    for (var i = 0; i < source.length; i++) {
        target.push(source[i]);
    }
};

customizer.initBasePrices = function initBasePrices() {
    var baseOption = null;
    var customOption = null;
    for (var i = 0; i < window.product.options.length; i++) {
        switch (window.product.options[i]) {
            case "Base":
                baseOption = "option" + (i + 1);
                break;
            case "Custom":
                customOption = "option" + (i + 1);
                break;
        }
    }
    $("[data-base-variant]").each(function(i, elem) {
        var base = $(elem).attr("data-base-variant");
        for (var j = 0; j < window.product.variants.length; j++) {
            var variant = window.product.variants[j];
            if (variant[baseOption] === base && variant[customOption] === "+$0.00") {
                $(elem).attr("data-base-price", (variant.price / 100).toFixed(2));
                break;
            }
        }
    });
};

customizer.formatSelection = function formatSelection(state) {
    var outer = $("<span class=\"customizerSpan\"></span");
    if ($(state.element).attr("data-image")) {
        var img = $("<img alt=\"\" />").prop("src", $(state.element).attr("data-image"));
        outer.append($("<div class=\"imgDiv\"></div").append(img));
    }
    var body = $("<span class=\"body\"></span>");
    outer.append(body);
    var top = $("<span class=\"top\"></span>");
    body.append(top);
    top.append($("<span class=\"text\"></span>").text(state.text));
    if ($(state.element).attr("data-base-price")) {
        top.append($("<span class=\"price\"></span>").text("$" + parseFloat($(state.element).attr("data-base-price")).toFixed(2)));
    }
    if ($(state.element).attr("data-price")) {
        top.append($("<span class=\"price\"></span>").text("+$" + parseFloat($(state.element).attr("data-price")).toFixed(2)));
    }
    return outer;
};

customizer.formatResult = function formatResult(state) {
    var outer = $("<span class=\"customizerSpan\"></span");
    if ($(state.element).attr("data-image")) {
        var img = $("<img alt=\"\" />").prop("src", $(state.element).attr("data-image"));
        outer.append($("<div class=\"imgDiv\"></div").append(img));
    }
    var body = $("<span class=\"body\"></span>");
    outer.append(body);
    var top = $("<span class=\"top\"></span>");
    body.append(top);
    top.append($("<span class=\"text\"></span>").text(state.text));
    if ($(state.element).attr("data-base-price")) {
        top.append($("<span class=\"price\"></span>").text("$" + parseFloat($(state.element).attr("data-base-price")).toFixed(2)));
    }
    if ($(state.element).attr("data-price")) {
        top.append($("<span class=\"price\"></span>").text("+$" + parseFloat($(state.element).attr("data-price")).toFixed(2)));
    }
    if ($(state.element).attr("data-description")) {
        body.append($("<span class=\"description\"></span>").text($(state.element).attr("data-description")));
    }
    return outer;
};

customizer.init = function() {
    var customizerDiv = $("#customizerDiv");

    customizer.initBasePrices();

    // select2
    $("select", customizerDiv).select2({
        placeholder: "Select an option",
        minimumResultsForSearch: Infinity,
        templateResult: customizer.formatResult,
        templateSelection: customizer.formatSelection
    });
    $("select", customizerDiv).on("change.customizer", function() {
        customizer.update();
    });

    // jquery.validate
    $("#customizerForm").validate({
        ignore: "input[type=hidden]",
        invalidHandler: function(e, validator) {
            var errors = validator.numberOfInvalids();
            if (errors) {
                var message = errors === 1
                    ? "Please specify 1 field highlighted below."
                    : "Please specify " + errors + " fields highlighted below.";
                $(".errorDiv .errorMessageSpan", customizerDiv).html(message);
                $(".errorDiv", customizerDiv).show();
            } else {
                $(".errorDiv", customizerDiv).hide();
            }
        },
        highlight: function(element, errorClass, validClass) {
            if ($(element).is(".select2-hidden-accessible")) {
                var sp = $(element).nextAll("span.select2:first");
                sp.addClass(errorClass).removeClass(validClass);
            } else {
                $(element).addClass(errorClass).removeClass(validClass);
            }
        },
        unhighlight: function(element, errorClass, validClass) {
            if ($(element).is(".select2-hidden-accessible")) {
                var sp = $(element).nextAll("span.select2:first");
                sp.removeClass(errorClass).addClass(validClass);
            } else {
                $(element).removeClass(errorClass).addClass(validClass);
            }
        }
    });
    $("select", customizerDiv).on("change", function() {
        $(this).valid();
    });

    // qtip2
    $(".tooltipLink").each(function() {
        $(this).qtip({
            content: {
                text: $(this).nextAll(".tooltipText:first"),
                button: true
            },
            show: {
                event: "click"
            },
            hide: {
                event: "click unfocus"
            }
        });
    });

    //
    customizer.update();

    // Preload images used in dropdowns.
    $("option[data-image]", customizerDiv).each(function(i, elem) {
        var src = $(elem).attr("data-image");
        if (src) {
            $("<img/>")[0].src = src;
        }
    });
};
